import React, {PropTypes} from 'react';

function AssessmentLaptop(props) {
  const {
    style: {
      color,
      backgroundColor
    } = {}
  } = props;

  return (
    <svg width="89px" height="69px" viewBox="0 0 89 69" version="1.1" xmlns="http://www.w3.org/2000/svg" >

<title>F4226A58-9FCC-4864-AD48-EB2395DBE4F1</title>
  <desc>Created with sketchtool.</desc>
  <defs></defs>
  <g id="501---Assesments" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
  <g transform="translate(-339.000000, -452.000000)" id="Group-2" fill="#333333">
  <g transform="translate(278.000000, 405.000000)">
  <g id="icon_laptop-copy" transform="translate(61.000000, 47.000000)">
  <g id="Icons">
  <g id="Group">
  <g id="Shape">
  <path d="M75.5871235,43.9009126 L13.1426336,43.9009126 C9.15056022,43.9009126 5.90030364,40.6549889 5.90030364,36.6682373 L5.90030364,7.23267536 C5.90030364,3.24592373 9.15056022,0 13.1426336,0 L75.589871,0 C79.5791969,0 82.8294534,3.24592373 82.8294534,7.23267536 L82.8294534,36.6682373 C82.8294534,40.6549889 79.5791969,43.9009126 75.5871235,43.9009126 L75.5871235,43.9009126 Z M13.1426336,5.48761408 C12.1782718,5.48761408 11.3952429,6.27234289 11.3952429,7.23267536 L11.3952429,36.6682373 C11.3952429,37.6285698 12.1782718,38.4132986 13.1426336,38.4132986 L75.589871,38.4132986 C76.5514853,38.4132986 77.3345142,37.6285698 77.3345142,36.6682373 L77.3345142,7.23267536 C77.3345142,6.27234289 76.5514853,5.48761408 75.5871235,5.48761408 L13.1426336,5.48761408 L13.1426336,5.48761408 Z"></path>
  <path d="M82.8129686,68.8613253 L5.91678846,68.8613253 C4.08422621,68.8613253 2.37804757,67.9942823 1.35049393,66.5373207 C0.375142206,65.1516982 0.138859818,63.447794 0.707586032,61.8618735 L8.82361134,40.1967731 L13.969622,42.1201819 L6.0129499,63.3572484 L82.7250496,63.3737112 L74.7848623,42.1174381 L79.930873,40.1995169 L88.0084337,61.8289478 C88.5908973,63.4505378 88.3546149,65.154442 87.3792632,66.5400645 C86.3517095,67.9915385 84.6455309,68.8613253 82.8129686,68.8613253 L82.8129686,68.8613253 Z"></path>
  <path d="M55.3712419,66.2876343 L53.9535476,55.029794 L34.9520476,54.8761408 L33.3585152,66.2876343 L30.6330253,65.9446584 L32.0507196,54.6868181 C32.1825982,53.2490632 33.4326969,52.1323338 34.9520476,52.1323338 L53.7777095,52.1323338 C55.2970602,52.1323338 56.5471589,53.2490632 56.6872799,54.730719 L58.0994793,65.9446584 L55.3712419,66.2876343 L55.3712419,66.2876343 Z"></path>
  </g>
  <g transform="translate(13.971660, 8.231421)" id="Shape">
  <path d="M1.54478745,10.9752282 C1.19311134,10.9752282 0.841435223,10.8407816 0.572183198,10.5746323 C0.0364266194,10.03959 0.0364266194,9.16980313 0.572183198,8.63476076 L8.81459211,0.403339635 C9.35034868,-0.131702738 10.2212966,-0.131702738 10.7570531,0.403339635 C11.2928097,0.938382008 11.2928097,1.80816884 10.7570531,2.34321121 L2.51464423,10.5746323 C2.24813968,10.8407816 1.89646356,10.9752282 1.54478745,10.9752282 L1.54478745,10.9752282 Z"></path>
  <path d="M1.54478745,21.9504563 C1.19311134,21.9504563 0.841435223,21.8160098 0.572183198,21.5498605 C0.0364266194,21.0148181 0.0364266194,20.1450313 0.572183198,19.6099889 L19.8044706,0.403339635 C20.3402272,-0.131702738 21.2111751,-0.131702738 21.7469317,0.403339635 C22.2826883,0.938382008 22.2826883,1.80816884 21.7469317,2.34321121 L2.51464423,21.5498605 C2.24813968,21.8160098 1.89646356,21.9504563 1.54478745,21.9504563 L1.54478745,21.9504563 Z"></path>
  </g>
  </g>
  </g>
  </g>
  </g>
  </g>
  </g>
  </svg>
  );
}

AssessmentLaptop.propTypes = {
  style: PropTypes.object
};

export default AssessmentLaptop;



// WEBPACK FOOTER //
// ./shared/common/svgs/AssessmentLaptop.js